<main>
    <div class="largeContainer">
        <div class="d-flex flex-row flex-space-between admin-page-header">
            <button (click)="back()" aria-label="Back" mat-icon-button matTooltip="Back">
                <mat-icon>keyboard_backspace</mat-icon>
            </button>
            <div><h1 class="admin-page-title">
                {{ subtitle }}
            </h1></div>
            <div class="admin-page-header-spacer" aria-hidden="true"></div>
        </div>
        @if (loading) {
            <div class="centerLoading">
                <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
            </div>
        }
        <div [hidden]="loading" class="mat-elevation-z6">
            <div class="flex-row gap-15 bg-white align-items-center flex-space-around filterExtraItems">
                <mat-form-field class="w-100 noBottomPadding" color="primary">
                    <mat-label>Category</mat-label>
                    <select [(ngModel)]="status" (ngModelChange)="page = 0; getMedia()" matNativeControl>
                        <option [value]="'All'">All</option>
                        <option [value]="'hidden'">Hidden</option>
                        <option [value]="'approval'">Awaiting Approval</option>
                        <option [value]="'flagged'">Flagged</option>
                    </select>
                </mat-form-field>
            </div>
            <table (matSortChange)="sortData($event)" [class.openSidebar]="largerTable" [dataSource]="dataSource"
                   [matSortActive]="order_by"
                   [matSortDirection]="direction" class="responsiveTable massiveTable"
                   mat-table
                   matSort>
                <ng-container matColumnDef="memoryBox">
                    <th *matHeaderCellDef mat-header-cell> Memory Box</th>
                    <td *matCellDef="let media" mat-cell>
                        <b class="d-none columnTitle">Memory Box :</b>
                        <a [routerLink]="['/timeline', media.timeline?.id]"
                           mat-button>{{ media.timeline| nameDisplay }}</a>
                    </td>
                </ng-container>
                <ng-container matColumnDef="author">
                    <th *matHeaderCellDef mat-header-cell> Uploader</th>
                    <td *matCellDef="let media" mat-cell>
                        <b class="d-none columnTitle">Uploader :</b>
                        @if (media.user && this.user && this.user.role.role_type == 'admin') {
                            <a [routerLink]="media.user?.timeline?.id ? ['/user', media.user?.id, media.user?.timeline?.id] : ['/user', media.user?.id]"
                               mat-button>{{ media.user| nameDisplay }}</a>
                        }
                        @if (media.user && this.user && this.user.role.role_type !== 'admin') {
                            <a [routerLink]="['/profile',media.user.id ]"
                               mat-button>{{ media.user| nameDisplay }}</a>
                        }
                    </td>
                </ng-container>
                <ng-container matColumnDef="author_role">
                    <th *matHeaderCellDef mat-header-cell>Uploader Role</th>
                    <td *matCellDef="let media" mat-cell>{{ media.user?.role.name }}
                    </td>
                </ng-container>
                <ng-container matColumnDef="img">
                    <th *matHeaderCellDef mat-header-cell></th>
                    <td *matCellDef="let media" mat-cell>
                        <img [src]="media.thumbnail||'assets/images/image.png'" alt="Media Thumbnail"
                             class="smallPreview">
                    </td>
                </ng-container>
                <ng-container matColumnDef="title">
                    <th *matHeaderCellDef mat-header-cell mat-sort-header> Title</th>
                    <td *matCellDef="let media" mat-cell>
                        <b class="d-none columnTitle">Title:</b> {{ media.title | ellipsis:30 }}
                    </td>
                </ng-container>
                <ng-container matColumnDef="file_type">
                    <th *matHeaderCellDef mat-header-cell mat-sort-header> File Type</th>
                    <td *matCellDef="let media" mat-cell>
                        <b class="d-none columnTitle">File Type:</b> {{ media.file_type| titlecase }}
                    </td>
                </ng-container>

                <ng-container matColumnDef="description">
                    <th *matHeaderCellDef mat-header-cell> Description</th>
                    <td *matCellDef="let media" mat-cell>
                        <b class="d-none columnTitle">Display Date:</b> {{ media.description }}
                    </td>
                </ng-container>
                <ng-container matColumnDef="hidden_status">
                    <th *matHeaderCellDef mat-header-cell mat-sort-header> Category</th>
                    <td *matCellDef="let media" mat-cell>
                        <b class="d-none columnTitle">Category:</b> {{ media.hidden_status == 'approval' ? 'Awaiting Approval' : media.hidden_status == 'flagged' ? 'Flagged' : 'Hidden' }}
                    </td>
                </ng-container>
                <ng-container matColumnDef="created_date">
                    <th *matHeaderCellDef mat-header-cell mat-sort-header> Upload Date</th>
                    <td *matCellDef="let media" mat-cell>
                        <b class="d-none columnTitle">Upload Date:</b> {{ media.created_date | date }}
                    </td>
                </ng-container>

                <ng-container matColumnDef="view">
                    <th *matHeaderCellDef mat-header-cell></th>
                    <td *matCellDef="let media" mat-cell>
                        @if (this.user && (this.user.role.can_manage_hidden_media || this.user.role.role_type == 'admin')) {
                            <a [routerLink]="['/hiddenMedia', media.id]" class="text-center" color="primary"
                               mat-raised-button>
                                View
                            </a>
                        }
                    </td>
                </ng-container>
                <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
                <tr *matRowDef="let row; columns: displayedColumns;" mat-row></tr>
                <tr *matNoDataRow class="mat-row">
                    @if (status.length > 0) {
                        <td [attr.colspan]="this.displayedColumns.length"
                            class="mat-cell text-center">No data matching these filters
                        </td>
                    } @else {
                        @if (!loading) {
                            <td [attr.colspan]="this.displayedColumns.length" class="mat-cell text-center">
                                No hidden media found
                            </td>
                        }
                    }
                </tr>
            </table>
            <mat-paginator (page)="handlePageEvent($event)" [length]="count"
                           [pageIndex]="page"
                           [pageSizeOptions]="[10, 15, 25, 50]"
                           [pageSize]="limit" aria-label="Select page"></mat-paginator>
        </div>
    </div>
</main>
